module.exports = {
    '点数卡储值': [{
        name: "PINHALL_mobile(台灣)",
        logo: "gash.png",
        paid: "COPGAM05",
        currencyCode: "PIN",
        erpId: "PINHALL",
        isGlobal: "yes",
        amount:{TWD: []}
    },{
        name: "PINHALL_mobile(非台灣)",
        logo: "gash.png",
        paid: "COPGAM05_no_tw",
        currencyCode: "PIN",
        erpId: "PINHALL",
        isGlobal: "yes",
        amount:{TWD: []}
    }],
    'GASH会员钱包转点': [{
        name: "錢包扣點(帳號綁定)",
        logo: "gash.png",
        paid: "COPGAM09",
        erpId: "",
        isGlobal: "no",
        amount:
            {TWD: [10, 20, 50, 100, 200, 300, 500, 1000]}
    }],
    '电信服务(台湾)': [{
        name: "台灣碩網-亞太電信手機",
        logo: "sg.jpg",
        paid: "TELSON04",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [50, 100, 150, 300, 500, 1000, 1500, 2000]}
    }, {
        name: "中華電信 手機 839(三合一)",
        logo: "ct.png",
        paid: "TELCHT05",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [50, 100, 150, 300, 500, 1000, 1500, 2000]}
    }, {
        name: "中華電信 Hinet(三合一)",
        logo: "ct.png",
        paid: "TELCHT06",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [50, 100, 150, 300, 500, 1000, 1500, 2000]}
    }, {
        name: "中華電信 市話(三合一)",
        logo: "ct.png",
        paid: "TELCHT07",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [50, 100, 150, 300, 500, 1000, 1500, 2000]}
    }, {
        name: "遠傳電信一般型",
        logo: "fet.png",
        paid: "TELFET01",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [50, 100, 150, 300, 500, 1000, 1200, 1500, 2000, 3000]}
    }, {
        name: "台灣大哥大一般型",
        logo: "tm.png",
        paid: "TELTCC01",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [50, 100, 150, 300, 500, 1000, 1500, 2000]}
    }],
    '金融服务(台湾)': [{
        name: "玉山銀行WEB ATM",
        logo: "esun.png",
        paid: "BNK80801",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [100, 150, 300, 500, 1000, 1200, 1500, 2000]}
    }, {
        name: "玉山銀行消費性扣款",
        logo: "esun.png",
        paid: "BNK80802",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [100, 150, 300, 500, 1000, 1200, 1500, 2000]}
    }, {
        name: "玉山支付通(支付寶)",
        logo: "esun.png",
        paid: "BNK80804",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [100, 150, 300, 500, 1000, 1200, 1500, 2000]}
    }, {
        name: "中國信託一般信用卡",
        logo: "ctbc.jpg",
        paid: "BNK82201",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [100, 150, 300, 500, 1000, 1500, 2000, 3000]}
    }, {
        name: "銀聯卡",
        logo: "union_pay.jpg",
        paid: "BNK82204",
        erpId: "J990001",
        isGlobal: "no",
        amount: {TWD: [50, 100, 150, 300, 500, 1000, 1500, 2000]}
    }],
    '线上购点服务(海外)': [{
        name: "HK-PAYPAL[USD]",
        logo: "paypal.png",
        paid: "COPPAL02",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {USD: [10, 50, 100, 200, 500, 1000, 1500, 2000, 3000, 5000]}
    }, {
        name: "HK-PAYPAL[EUR]",
        logo: "paypal.png",
        paid: "COPPAL02",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {EUR: [10, 50, 100, 200, 500, 1000, 1500, 2000, 3000, 5000]}
    }, {
        name: "HK-PAYPAL[HKD]",
        logo: "paypal.png",
        paid: "COPPAL02",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {HKD: [10, 50, 100, 200, 500, 1000, 1500, 2000, 3000, 5000]}
    }, {
        name: "RBS[USD]",
        logo: "rbs.png",
        paid: "BNKRBS01",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {USD: [10, 20, 50, 100, 150, 200, 300, 375]}
    }, {
        name: "RBS[EUR]",
        logo: "rbs.png",
        paid: "BNKRBS01",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {EUR: [10, 20, 50, 100, 150, 200, 300, 375]}
    }, {
        name: "GudangVoucher",
        logo: "gv.jpg",
        paid: "COPGV01",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {IDR: [10, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000]}
    },
    //   {
    //     name: "支付寶",
    //     logo: "alipay.jpg",
    //     paid: "COPALI02",
    //     erpId: "J990001",
    //     isGlobal: "yes",
    //     amount: {USD: [10, 50, 100, 200, 500, 1000, 1500, 2000, 3000, 5000]}
    // },
      {
        name: "PAYSBUY Co., Ltd",
        logo: "paysbuy.png",
        paid: "COPPSB01",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {THB: [10, 20, 50, 100, 200, 500, 1000, 1500, 2000]}
    }, {
        name: "PeaceSoft Solutions Co.,",
        logo: "peacesoft.jpg",
        paid: "COPPST01",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {VND: [2000, 5000, 10000, 20000, 50000, 100000, 150000, 200000, 500000]}
    }, {
        name: "Webcash-馬幣",
        logo: "webcash.png",
        paid: "COPWBC02",
        erpId: "J990001",
        isGlobal: "yes",
        amount: {MYR: [10, 20, 50, 100, 150, 200, 300]}
    }]
}



// WEBPACK FOOTER //
// ./src/config/pay/gash.js